<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="!isEdit"> Neuer Mitarbeiter</ion-title>
    <ion-title *ngIf="isEdit"> Mitarbeiter bearbeiten</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div>
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.user.firstName"
        ><div slot="label">Vorname</div></ion-input
      >
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.user.lastName"
        ><div slot="label">Nachname</div></ion-input
      >
      <div style="padding: 10px" *ngIf="!this.isEdit && userExists()">
        Info: Ein User mit diesem Namen existiert bereits
      </div>
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="number"
        mode="md"
        [(ngModel)]="this.user.workingHoursPerDay"
        ><div slot="label">Arbeitstunden pro Tag</div></ion-input
      >
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.user.personalNumber"
        ><div slot="label">Personalnummer</div></ion-input
      >
      <ion-select
        label="Typ"
        label-placement="floating"
        fill="outline"
        [(ngModel)]="this.user.type"
        mode="md"
      >
        <ion-select-option *ngFor="let tp of userTypes" [value]="tp">
          {{ getUserTypeLabel(tp) }}
        </ion-select-option>
      </ion-select>
      <div style="padding: 0 6px; margin-bottom: 10px">
        <ion-toggle
          helperText="Wirkt sich auf verschiedenen Funktionen aus. Siehe Hilfe im Bereich Mitarbeiter"
          justify="space-between"
          [(ngModel)]="this.user.recievesFixedSalary"
        >
          Mitarbeiter bekommt Fixgehalt
        </ion-toggle>
      </div>

      <ion-input
        *ngIf="this.showPassword"
        labelPlacement="floating"
        label="Passwort"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.user.password"
      >
        <ion-icon
          name="refresh-outline"
          slot="end"
          (click)="generatePassword()"
          style="cursor: pointer; font-size: 1.5em"
        ></ion-icon>
      </ion-input>
      <!--div class="select-form">
      <ion-checkbox
        stlye="margin-bottom:10px"
        [(ngModel)]="this.report.securityCheck"
        >Sicherheitscheck</ion-checkbox
      >
    </div-->

      <div *ngIf="showPassword" style="padding: 0 5px 5px 5px">
        Passwort bitte gut verwahren! Das Passwort ist nach dem Erstellen nicht
        mehr einsehbar! Das Passwort muss min. 12 Stellen, Zahlen und Buchstaben
        enthalten.
      </div>
      <div *ngIf="isEdit" class="wide top-item">
        <div>Benutzername:</div>
        <div>
          {{ this.userToEdit.userName }}
        </div>
      </div>

      <div *ngIf="isEdit" class="wide normal-item">
        <div>Erstellt:</div>
        <div>
          {{ tools.formatDt(this.userToEdit.createdUtc) }}
          {{ tools.formatTime(this.userToEdit.createdUtc) }}
        </div>
      </div>
      <div *ngIf="isEdit" class="wide normal-item">
        <div>Zuletzt Online:</div>
        <div>
          {{ tools.formatDt(this.userToEdit.lastLogin) }}
          {{ tools.formatTime(this.userToEdit.lastLogin, true) }}
        </div>
      </div>
      <div *ngIf="isEdit && this.user.isDeactivated" class="wide normal-item">
        <div>Deaktiviert:</div>
        <div>
          {{ tools.formatDt(this.userToEdit.deactivatedUtc) }}
          {{ tools.formatTime(this.userToEdit.deactivatedUtc) }}
        </div>
      </div>
    </div>
    <div [ngClass]="{ ios: this.platform.is('ios') }">
      <ion-button
        *ngIf="isEdit && !showPassword && !this.user.isDeactivated"
        (click)="this.generatePassword()"
        >Neues Passwort generieren</ion-button
      >
      <ion-button
        *ngIf="!isEdit"
        [disabled]="hasInvalidFields()"
        (click)="registerUser()"
        >Mitarbeiter registrieren</ion-button
      >
      <ion-button
        *ngIf="isEdit && !this.user.isDeactivated"
        [disabled]="hasInvalidFields()"
        (click)="updateUser()"
        >Mitarbeiter aktualisieren</ion-button
      >
      <ion-button
        *ngIf="isEdit && !this.user.isDeactivated"
        color="warning"
        (click)="deactivateUser()"
        >Deaktivieren</ion-button
      >
      <ion-button
        *ngIf="this.user.isDeactivated"
        color="success"
        (click)="activateUser()"
        >Aktivieren</ion-button
      >
      <ion-button *ngIf="isEdit" color="danger" (click)="deleteUser()"
        >Löschen</ion-button
      >
    </div>
  </div>
</ion-content>
